var path = 'infrastructure/directives/views/octo-clippy.html';
var html = "<div class=\"clippy note note-info\"> <img src=" + require("../../../img/layout/octoclippy.png") + " width=64 height=64 alt=\"Octoclippy is here to help!\" title=\"Octoclippy is here to help!\" class=pull-left /> <div class=\"clippy-says padding-sm-vr\" ng-transclude></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/views/octo-clippy.html
// module id = 1803217392693785
// module chunks = 1